var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayOrigin = function SvgPlayOrigin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#clip0_2754_17275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.95 5.56c-3.41-3.41-8.97-3.41-12.38 0A8.68 8.68 0 0 0 3 11.75c0 2.34.91 4.54 2.57 6.19a8.72 8.72 0 0 0 6.19 2.56c2.24 0 4.48-.85 6.19-2.56 3.41-3.41 3.41-8.97 0-12.38m-6.19 13.42c-3.98 0-7.23-3.24-7.23-7.23s3.24-7.22 7.23-7.22 7.23 3.24 7.23 7.23-3.24 7.23-7.23 7.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.31 8.3a.765.765 0 0 0-1.15.67v5.58c0 .59.64.96 1.15.67l4.83-2.79c.51-.3.51-1.04 0-1.33l-4.83-2.79z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2754_17275"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h17.51v17.5H3z"
  })))));
};
export default SvgPlayOrigin;